export default "__VITE_ASSET__CntmRg9F__"